import styled from 'styled-components';

import { color, font } from 'shared/utils/styles';

const EditorCont = styled.div`
  .ql-toolbar.ql-snow {
    border-radius: var(--radiusModal) var(--radiusModal); 0 0;
    border: 1px solid ${color.borderLightest};
    border-bottom: none;
  }
  .ql-container.ql-snow {
    border-radius: 0 0 4px 4px;
    border: 1px solid ${color.borderLightest};
    border-top: none;
    color: ${color.textDarkest};
    ${font.size(15)}
    ${font.regular}
  }
  .ql-editor {
    min-height: 110px;
  }
`;

export default EditorCont;
